// Ideias de lembranças/mimos impressos em 3D — catálogo inicial da parceria
// com a T&C 3D. As imagens em public/images/mimo3d/ são geradas por IA
// (gpt-image-2) como prévia conceitual, não fotos reais dos modelos —
// trocar pelas fotos de verdade assim que a T&C 3D entregar as primeiras peças.
export const MIMO3D_MODELS = [
  {
    id: 'casal-mini',
    label: 'Casal em Miniatura',
    description: 'Estatueta estilizada do casal, perfeita pra topo de bolo ou centro de mesa.',
    image: '/images/mimo3d/casal-mini.jpg',
  },
  {
    id: 'abridor-garrafa',
    label: 'Abridor de Garrafa',
    description: 'Lembrancinha prática pro casal entregar aos convidados na saída da festa.',
    image: '/images/mimo3d/abridor-garrafa.jpg',
  },
  {
    id: 'chaveiro',
    label: 'Chaveiro Lembrancinha',
    description: 'Lembrancinha em miniatura pros convidados levarem pra casa.',
    image: '/images/mimo3d/chaveiro.jpg',
  },
  {
    id: 'porta-guardanapo',
    label: 'Porta-Guardanapo com Iniciais',
    description: 'Detalhe pra mesa posta com as iniciais do casal em relevo.',
    image: '/images/mimo3d/porta-guardanapo.jpg',
  },
  {
    id: 'vaso-centro-mesa',
    label: 'Vasinho Centro de Mesa',
    description: 'Vaso impresso sob medida pra flores ou velas na decoração das mesas.',
    image: '/images/mimo3d/vaso-centro-mesa.jpg',
  },
  {
    id: 'marcador-lugar',
    label: 'Marcador de Lugar',
    description: 'Suporte de nome personalizado pra cada convidado encontrar seu lugar.',
    image: '/images/mimo3d/marcador-lugar.jpg',
  },
  {
    id: 'porta-retrato',
    label: 'Porta-Retrato 3D',
    description: 'Moldura com textura e relevo pra eternizar uma foto do casal.',
    image: '/images/mimo3d/porta-retrato.jpg',
  },
  {
    id: 'luminaria-nome',
    label: 'Luminária com Nome',
    description: 'Luminária de mesa com o nome do casal ou a data do casamento vazada na luz.',
    image: '/images/mimo3d/luminaria-nome.jpg',
  },
  {
    id: 'porta-vela',
    label: 'Porta-Vela Romântico',
    description: 'Suporte de vela com padrão vazado pra criar um jogo de luz e sombra na mesa.',
    image: '/images/mimo3d/porta-vela.jpg',
  },
  {
    id: 'placa-boas-vindas',
    label: 'Placa de Boas-Vindas',
    description: 'Placa de entrada da festa com os nomes do casal e a data, em relevo 3D.',
    image: '/images/mimo3d/placa-boas-vindas.jpg',
  },
];
